import React, { PropsWithChildren } from 'react'
import { ConfigurableCtaOptions } from '@typesApp/PageFlow'
import { ButtonLink } from '@components/ui-css/ButtonLink'
import { Button, ButtonProps } from '@components/ui-css/Button'

type ConfigurableActionProps = {
  options: ConfigurableCtaOptions
  onClick?: () => void
  label?: string
  busy?: boolean
  ignoreBusy?: boolean
  disabled?: boolean
  disableOnClick?: boolean
  type?: 'submit' | 'button' | 'reset' | undefined
  form?: string
  className?: string
  color?: ButtonProps['color']
  dataAttributes?: Record<string, string>
} & PropsWithChildren

export const ConfigurableAction: React.FC<ConfigurableActionProps> = props => {
  const {
    onClick,
    label,
    disabled = false,
    busy = false,
    ignoreBusy = false,
    disableOnClick = false,
    type,
    form,
    className,
    options,
    dataAttributes,
    children,
    color,
    ...rest
  } = props
  const { renderAs, underline, variant, componentProps } = options

  const handleClick = () => {
    onClick?.()
  }

  // @TODO: modify configuration to use correct button variant values
  const buttonVariantMap = {
    primary: 'contained',
    secondary: 'outlined',
  } as Record<'primary' | 'secondary', ButtonProps['variant']>

  return (
    <>
      {renderAs === 'link' && (
        <ButtonLink
          underline={underline}
          onClick={handleClick}
          disableOnClick={disableOnClick}
          disabled={disabled}
          isLoading={busy}
          className={className}
          {...dataAttributes}
          {...componentProps}
          {...rest}
        >
          {label}
          {children}
        </ButtonLink>
      )}

      {renderAs === 'button' && (
        <Button
          variant={variant ? buttonVariantMap[variant] : undefined}
          color={color}
          onClick={handleClick}
          disableOnClick={disableOnClick}
          disabled={disabled}
          isLoading={busy}
          className={className}
          form={form}
          type={type}
          {...dataAttributes}
          {...componentProps}
          {...rest}
        >
          {label}
          {children}
        </Button>
      )}
    </>
  )
}
